import { Injectable } from '@angular/core';
import labels from '../../assets/labels.json';

@Injectable({ providedIn: 'root' })
export class LabelService {
  private labels: any = labels;
  private currentSetting = 'default';
  
  setSetting(setting: string) {
    this.currentSetting = setting || 'default';
  }

  getLabel(key: string): string {
    return (
      this.labels[this.currentSetting]?.[key] ||
      this.labels['default']?.[key] ||
      key
    );
  }
}
